import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateVehicleInput,
    ModelSortDirection,
    UpdateVehicleInput,
    Vehicle
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class VehicleService {
    private amplifyClient = generateClient();

    constructor() {}

    async getVehicle(id: string): Promise<Vehicle> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getVehicle,
                    variables: {
                        id
                    }
                })
            ).data.getVehicle;
            if (data) return data as Vehicle;
        } catch (error) {
            console.error('Error Vehicle:', error);
            return null;
        }
    }

    async listAllVehicles(pageLimit: number = 100): Promise<Vehicle[]> {
        const vehicles: Vehicle[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listVehicles,
                        variables: {
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.listVehicles;
                vehicles.push(...((response?.items ?? []) as Vehicle[]));
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return vehicles;
        } catch (error) {
            console.error('Error Vehicle:', error);
            return [];
        }
    }

    async getVehiclesBestSellers(): Promise<Vehicle[]> {
        try {
            let vehiclesBD: Vehicle[] = [];
            let items;
            let params: any = null;
            items = (
                await this.amplifyClient.graphql({
                    query: queries.VehiclesByBestSellers,
                    variables: {
                        bestSeller: 'active',
                        limit: 60,
                        sortDirection: ModelSortDirection.ASC,
                        // filter: this.getFilter(),
                        nextToken: params ? params : null
                    }
                })
            ).data.VehiclesByBestSellers;
            items.items.forEach((item: Vehicle) => {
                vehiclesBD.push(item);
            });
            params = items.nextToken;
            return vehiclesBD;
        } catch (err) {
            console.log(err);
            return [];
        }
    }

    async vehiclesByType(vehicleTypeId: string): Promise<Vehicle[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.vehiclesByType,
                    variables: {
                        vehicleTypeId
                    }
                })
            ).data.vehiclesByType.items;
            if (data) return data as Vehicle[];
        } catch (error) {
            console.error('Error Vehicle:', error);
            return null;
        }
    }

    async vehiclesbyChanel(popMaterialId: string): Promise<Vehicle[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.VehiclesbyChanel,
                    variables: {
                        popMaterialId
                    }
                })
            ).data.VehiclesbyChanel.items;
            if (data) return data as Vehicle[];
        } catch (error) {
            console.error('Error Vehicle:', error);
            return null;
        }
    }

    async vehiclesbyPopCategory(popCategoryId: string): Promise<Vehicle[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.VehiclesbyPopCategory,
                    variables: {
                        popCategoryId
                    }
                })
            ).data.VehiclesbyPopCategory.items;
            if (data) return data as Vehicle[];
        } catch (error) {
            console.error('Error Vehicle:', error);
            return null;
        }
    }
    async vehiclesByProvider(providerId: string): Promise<Vehicle[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.vehiclesByProvider,
                    variables: {
                        providerId
                    }
                })
            ).data.vehiclesByProvider.items;
            if (data) return data as Vehicle[];
        } catch (error) {
            console.error('Error Vehicle:', error);
            return null;
        }
    }
    async vehiclesByMassiveLayout(massiveLayout: string): Promise<Vehicle[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.VehiclesByMassiveLayout,
                    variables: {
                        massiveLayout
                    }
                })
            ).data.VehiclesByMassiveLayout.items;
            if (data) return data as Vehicle[];
        } catch (error) {
            console.error('Error Vehicle:', error);
            return null;
        }
    }

    async listAllVehiclesByMassiveLayout(
        massiveLayout: string,
        pageLimit: number = 100
    ): Promise<Vehicle[]> {
        const vehicles: Vehicle[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.VehiclesByMassiveLayout,
                        variables: {
                            massiveLayout,
                            nextToken,
                            limit: pageLimit
                        }
                    })
                ).data.VehiclesByMassiveLayout;

                if (response?.items) {
                    vehicles.push(...(response.items as Vehicle[]));
                }
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);

            return vehicles;
        } catch (error) {
            console.error('Error Vehicle:', error);
            return [];
        }
    }

    async createVehicle(input: CreateVehicleInput): Promise<Vehicle> {
        try {
            const vehicle = (
                await this.amplifyClient.graphql({
                    query: mutations.createVehicle,
                    variables: {
                        input
                    }
                })
            ).data.createVehicle;
            if (vehicle) return vehicle as Vehicle;
        } catch (error) {
            console.error('Error creating Vehicle::', error);
            return null;
        }
    }

    async updateVehicle(input: UpdateVehicleInput): Promise<Vehicle> {
        try {
            const vehicle = (
                await this.amplifyClient.graphql({
                    query: mutations.updateVehicle,
                    variables: {
                        input
                    }
                })
            ).data.updateVehicle;
            if (vehicle) return vehicle as Vehicle;
        } catch (error) {
            console.error('Error updating vehicle:', error);
            return null;
        }
    }
}
